<script setup>
import InvoicesCollectionsReportComponent from "@/Components/Invoices/InvoicesCollectionsReportComponent.vue";
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" style="min-height: 100vh;">
        <InvoicesCollectionsReportComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>